import script from "./ChangeChannelDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeChannelDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeChannelDialog.vue?vue&type=style&index=0&id=c2af0bce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2af0bce"]])

export default __exports__